import React from 'react';

import { Box, Typography } from '@mui/material';

import withoutPortfolio from 'assets/icons/without-portfolio.svg';

interface Props {
  minHeight?: string;
  messages: string[];
  children?: React.ReactNode;
}

const CustomEmpty = ({ messages, minHeight = '70vh', children }: Props) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
      width="100%"
      padding={4}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
      >
        <img src={withoutPortfolio} alt="without-portfolio" />
        <Box marginTop={4} />

        {messages.map((message, index) => (
          <React.Fragment key={index}>
            <Typography
              variant="h6"
              fontWeight="normal"
              lineHeight="26px"
              letterSpacing="0.2px"
            >
              {message}
            </Typography>
            <Box marginTop={4} />
          </React.Fragment>
        ))}
        {children}
      </Box>
    </Box>
  );
};

export default CustomEmpty;
